import { createAction } from "@reduxjs/toolkit";

export const LogoutAction = createAction("logout");
